module.exports = __webpack_public_path__ + "static/img/materialsax03.d7a2b0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsax03.png
// module id = 2i2G
// module chunks = 2